import axios from "axios/index";
import Config from '../config';
import {notification} from "../helpers";

/**
 * Get list of stations
 */
export function get() {
    return (dispatch) => {
        return axios.get(Config.api.getDomain() + 'station/Stations',Config.api.getConfig())
          .then(response => {
            dispatch({
              type: 'STATIONS_GET_SUCCESS',
              payload: response.data
            });
            dispatch({
              type: 'REFRESH_FETCH_FALSE',
              payload: { key:"stations"}
            });
          })
          .catch(error => {
            notification("Did not get stations!");
            dispatch({
              type: 'STATIONS_GET_FAILED',
              payload: error
            });
          })
    };
}


export function getGroups() {
  return (dispatch) => {
    return axios.get(Config.api.getDomain() + 'station/groups', Config.api.getConfig())
      .then(res => {
        const groups = res.data;
        dispatch({
          type: 'STATIONS_GET_GROUPS_SUCCESS',
          payload: groups
        });

        dispatch({
          type: 'REFRESH_FETCH_FALSE',
          payload: {
              key:"stationGroups"
          }
        });

      })
      .catch(error => {
        //notification("Something went wrong, could not get station groups!");
        console.log(error);
      })
  };
}

/**
 * Get statistics of the stations
 */
export function getAllStationStats() {
    return (dispatch) => {
        return axios.get(Config.api.getDomain() + 'station/statistics',Config.api.getConfig())
            .then(response => {
              dispatch({
                type: 'STATIONS_ALL_STATS_GET_SUCCESS',
                payload: response.data
              });
            })
            .catch(error => {
              dispatch({
                type: 'STATIONS_ALL_STATS_GET_FAILED',
                payload: error
              });
            })
    };
}

export function getStationStats(stationId) {
    return (dispatch) => {
        return axios.get(Config.api.getDomain() + 'station/statisticsByStation/'+stationId,Config.api.getConfig())
            .then(response => {
                dispatch({
                    type: 'STATIONS_STATS_GET_SUCCESS',
                    payload: {
                        actualSpikes:parseInt(response.data.actualSpikes,10),
                        desiredFriction:parseInt(response.data.desiredFriction,10),
                        desiredSpikes:parseInt(response.data.desiredSpikes,10),
                        name:response.data.name,
                        numberOfWheels:parseInt(response.data.numberOfWheels,10),
                        onStation:parseInt(response.data.onStation,10),
                        orders:parseInt(response.data.orders,10),
                        outgoing:parseInt(response.data.outgoing,10)
                    }
                });
            })
            .catch(error => {
                dispatch({
                    type: 'STATIONS_STATS_GET_FAILED',
                    payload: error
                });
            })
    };
}

export function post(data){


    return (dispatch)=>{
        // Posta till user/Create

        dispatch({
            type: 'STATIONS_CREATE_INPROGRESS',
            payload: data
        });
        return axios.post(Config.api.getDomain() + 'station', data, Config.api.getConfig())
            .then(response => {
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {key:"stationGroups"}
                });
                notification('Grupp skapad!');
                dispatch({
                    type: 'STATIONS_CREATE_SUCCESS',
                    payload: response
                });
            })
            .catch(error => {

                if (typeof(error.response)!=="undefined" && typeof(error.response.data)!=="undefined"){

                    let errorCodes = error.response.data;
                    if (typeof(errorCodes)!=="undefined" && typeof(errorCodes.message)!=="undefined"){
                        notification('Misslyckades med att skapa gruppen! '+errorCodes.message);
                    } else {
                        notification('Misslyckades med att skapa gruppen!');
                    }

                } else {
                    notification('Misslyckades med att skapa gruppen!');
                }

                dispatch({
                    type: 'STATIONS_CREATE_FAILURE',
                    payload: error
                });
            })
    }
}

export function put(data){
    if (Number.isInteger(parseInt(data.stationId, 10))) {
        return (dispatch) => {
            dispatch({
                type: 'STATIONS_UPDATE_INPROGRESS',
                payload: data
            });
            return axios.put(Config.api.getDomain() + 'station/put', data, Config.api.getConfig()).then((response) => {
                dispatch({
                    type: 'STATIONS_UPDATE_SUCCESS',
                    payload: response
                });
                notification("Grupp är ändrad!");
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {
                        key:"stationGroups"
                    }
                });
                return Promise.resolve(true);
            }).catch(error => {

                dispatch({
                    type: 'STATIONS_UPDATE_FAILURE',
                    payload: error
                });
                notification("Gruppuppdatering misslyckades");
                return error;
            });
        }
    } else {

        return (dispatch) => {
            dispatch({
                type: 'STATIONS_UPDATE_FAILURE',
                payload: {"message": "No user id"}
            });
            notification("message gor failure");
        };
    }
}

export function getGroupTypes(){

    return (dispatch)=>{
        return axios.get(Config.api.getDomain() + 'station/types', Config.api.getConfig())
            .then(res => {
                const groupTypes = res.data;
                dispatch({
                    type: 'STATIONS_GET_GROUP_TYPES_SUCCESS',
                    payload: groupTypes
                });

            })
            .catch(error => {
                console.log(error);
                dispatch({
                    type: 'STATIONS_GET_GROUP_TYPES_FAILED',
                    payload: []
                });
            })

    }
}

export function destroy(id) {
    if (Number.isInteger(parseInt(id, 10))) {
        return (dispatch) => {
            return axios.delete(Config.api.getDomain() + 'admin/deletestation/' + id, Config.api.getConfig()).then((response) => {
                dispatch({
                    type: 'STATION_DESTROY_SUCCESS',
                    payload: response
                });
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {
                        key:"stationGroups"
                    }
                });
                notification("Raderades framgångsrikt!");
                return Promise.resolve(true);
            }).catch(error => {
                dispatch({
                    type: 'STATION_DESTROY_FAILURE',
                    payload: error
                });
                notification("Raderade misslyckades!");
                return error;
            });
        }
    } else {

        return (dispatch) => {
            dispatch({
                type: 'STATION_DESTROY_FAILURE',
                palyload: {"message": "No station id passed"}
            });
        };
    }
}



// WEBPACK FOOTER //
// ./src/actions/stations.js